/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import moment from 'moment';
import {useRouter} from 'next/router';

import Link from '../../components/Link';
import {RightArrowIcon} from '../../components/svg';
import {useAnalytics} from '../../hooks';

const GuideCard = ({guide, tag}) => {
  const {tracker} = useAnalytics();
  const router = useRouter();
  const url = `/guides/${guide.slug}`;

  const handleClick = () => {
    tracker.hubClickCard({type: 'guides', tag: tag.id, slug: guide.slug});
    router.push(url);
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer p-4 border border-gray-200 rounded-lg transition hover:border-gray-300 hover:bg-gray-50 flex flex-col justify-between"
    >
      <div className="mb-3">
        <Link href={url}>
          <h3 className="text-base font-semibold text-gray-900">
            {guide.roleName || guide.name}
          </h3>
        </Link>
        <span className="mt-0.5 block text-sm text-gray-500">
          {guide.updatedAt && `Updated ${moment(guide.updatedAt).fromNow()}`}
        </span>
      </div>
      <span className="mt-auto ml-auto inline-flex items-center text-sm font-medium text-indigo">
        View guide
        <RightArrowIcon className="w-4 ml-1.5" />
      </span>
    </div>
  );
};

export default GuideCard;
